import {TimelineLite, TweenLite} from "gsap";
import {Oktoberfest} from "../Oktoberfest";
import {GameHelper} from "../../core/utils/GameHelper";
import {OktoberfestGameConfig} from "../OktoberfestGameConfig";
import {OktoberfestSound} from "../sound/OktoberfestSound";
import {Layers, OktoberfestLayers} from "./OktoberfestLayers";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

/**
 * Created by Shikha on 09/13/2021.
 */


export class GameNearWinReelsView extends PIXI.Container {
    protected _nearWinContainer: PIXI.Container;
    protected _nearWinDividers: PIXI.Container[];
    private _dividerChainNearWin: PIXI.Sprite;
    private _nearWinFadingTween: TimelineLite;
    private _activeReelId: number = -1;
    private glowChainAnim: TweenLite;
    private _chainMaxOffset: number = 0;
    private _isSpinning: boolean;
    private _reelDividerIndexMap: number[][] = [[0, 1], [1, 2], [2, 3], [3, 4], [4, 5]];

    constructor() {
        super();
        this.initAnimations();
        OktoberfestLayers.getLayer(Layers.GLOW_DIVIDERS)!.addChild(this);
        this.onOrientationChanged();
    }

    public initAnimations(): void {
        this._nearWinContainer = new PIXI.Container();
        this._chainMaxOffset = 100;
        this._nearWinContainer.y += 5;
        this.addChild(this._nearWinContainer);
        this._nearWinDividers = [];
        let positionsX: number[] = OktoberfestGameConfig.reelDividerPosX;
        for (let i: number = 0; i < positionsX.length; i++) {
            let nearWinDivider: PIXI.Container = this.createNearWinDivider(i);
            nearWinDivider.x = positionsX[i];
            nearWinDivider.y = 25;
            nearWinDivider.alpha = 0;
            if (i === 0) {
                nearWinDivider.x = -31;
                nearWinDivider.y = 50;
            }
            this._nearWinContainer.addChild(nearWinDivider);
            this._nearWinDividers.push(nearWinDivider);

        }

    }

    public onReelSpinAnimationComplete(stopData: { reelId: number }): void {
        if (stopData.reelId != this._activeReelId) {
            return;
        }
        this._isSpinning = false;
        this._nearWinFadingTween = new TimelineLite();
        let activeDividerIndexes: number[] = this._reelDividerIndexMap[this._activeReelId];
        for (let i: number = 0; i < activeDividerIndexes.length; i++) {
            this._nearWinFadingTween.add(new TweenLite(this._nearWinDividers[activeDividerIndexes[i]], 0.2, {alpha: 0}), 0);
        }
        this.onDividerChainPositionUpdate();
        this.stopNearWinSound(stopData.reelId);
    }

    public onPlayReelNearWinAttention(reelId: number): void {
        if (this._nearWinFadingTween && this._nearWinFadingTween.isActive()) {
            this._nearWinFadingTween.kill();
        }
        for (let i: number = 0; i < this._nearWinDividers.length; i++) {
            this._nearWinDividers[i].alpha = 0;
        }
        this._isSpinning = true;
        this._activeReelId = reelId;
        Oktoberfest.dimOverLay.onDimStage();
        this._nearWinFadingTween = new TimelineLite();
        let activeDividerIndexes: number[] = this._reelDividerIndexMap[this._activeReelId];
        for (let i: number = 0; i < activeDividerIndexes.length; i++) {
            this._nearWinFadingTween.add(new TweenLite(this._nearWinDividers[activeDividerIndexes[i]], 0.1, {alpha: 1}), 0);
        }
        this.playDividerChainAnimation();
        this.playNearWinSound(reelId);
    }

    public onOrientationChanged(): void {
        if (!NolimitApplication.isLandscape) {
            this._chainMaxOffset = 15;
            this._dividerChainNearWin.y=50;
        } else {
            this._chainMaxOffset = 100;
            this._dividerChainNearWin.y=50;
        }

    }

    protected playNearWinSound(reelId: number): void {
        if (reelId == 3 && this.isCheeringAnticipation()) {
            OktoberfestSound.playSoundEffect(OktoberfestSound.SOUND_NAME_ANTICIPATION_REEL_FOUR_CHEERING_MODE)
        } else {
            OktoberfestSound.playSoundEffect(OktoberfestSound.getAnticipationSound(reelId));
        }
    }

    private stopNearWinSound(reelId: number): void {
        if (reelId == 3 && this.isCheeringAnticipation()) {
            OktoberfestSound.soundPlayer.stopTrack(OktoberfestSound.SOUND_NAME_ANTICIPATION_REEL_FOUR_CHEERING_MODE);
        } else {
            OktoberfestSound.soundPlayer.stopTrack(OktoberfestSound.getAnticipationSound(reelId));
        }
    }

    /**
     * Checks if a the woman stacked wild is fully visible on reel 1. If so the anticipation is in "cheering mode"
     * @returns {boolean}
     */
    private isCheeringAnticipation(): boolean {
        const reels: string[][] = Oktoberfest.model.parsedGameData.reels;
        return GameHelper.isReel2Stacked(reels);
    }

    private createNearWinDivider(index: number): PIXI.Container {
        let sprite: PIXI.Sprite;
        if (index === 0) {
            this._dividerChainNearWin = new PIXI.Sprite(Oktoberfest.assetLoader.getTextures("reelDivider")[0]);
            this._dividerChainNearWin.texture = this.createChainTexture("chainGlowPart");
            sprite = this._dividerChainNearWin;
            sprite.x = -25;
            sprite.y = 100;


        } else {
            sprite = new PIXI.Sprite(Oktoberfest.assetLoader.getTextures("nearWinReelDivider")[0]);
            sprite.anchor.set(0.5, 0);
            sprite.x -= sprite.width / 2;

        }
        sprite.y += 20;
        sprite.scale.set(1.2, 1);
        return sprite;
    }

    private createChainTexture(textureName: string): PIXI.Texture {
        let chainPartContainer: PIXI.Container = new PIXI.Container();
        let resolution: number = (Oktoberfest.assetLoader.getTextures(textureName)[0]).baseTexture.resolution;

        for (let i: number = 0; i < 7; i++) {
            let chainPartSprite: PIXI.Sprite = new PIXI.Sprite((Oktoberfest.assetLoader.getTextures(textureName)[0]));
            chainPartSprite.y = (i * chainPartSprite.height);
            chainPartContainer.y += 10;
            chainPartContainer.addChild(chainPartSprite);
        }
        return GameHelper.createRenderedTextureFromContainer(chainPartContainer, resolution);
    }

    private playDividerChainAnimation(): void {
        // the kill tween doesn't work sometime when spin stop, so use this boolean to double check.
        if (!this._isSpinning) {
            return;
        }
        this.glowChainAnim = TweenLite.to(this._dividerChainNearWin, {
            duration: 0.07,
            y: this._dividerChainNearWin.y - 10,
            onUpdate: () => this.onDividerChainPositionUpdate(),
            onComplete: () => this.playDividerChainAnimation()
        });
    }

    private onDividerChainPositionUpdate(): void {
        if (this._dividerChainNearWin.y <= 0 - this._chainMaxOffset) {
            this.glowChainAnim.kill();
            this._dividerChainNearWin.y += this._chainMaxOffset;
            this.playDividerChainAnimation();
        }
    }
}
